/**
 * Clamp value.
 * Detects proper clamp min/max.
 *
 * @param {number} a Current value to cut off
 * @param {number} min One side limit
 * @param {number} max Other side limit
 *
 * @return {number} Clamped value
 */
'use strict';
module.exports = function(a, min, max){
	return max > min ? Math.max(Math.min(a,max),min) : Math.max(Math.min(a,min),max);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/color-space/node_modules/mumath/clamp.js
// module id = kxYn
// module chunks = 0